import React from "react";

import Loading from "../../Common/Loading";
import EditInput from "./EditInput";
import DesktopEdit from "./components/DesktopEdit";
import Api from "../../../lib/componentApi";
import getAppErrors from "../../../lib/appErrors";
import AppErrors from "../../Common/AppErrors";

export default class Edit extends React.PureComponent {
  state = {
    selectedSection: "",
    passwordSection: false,
    errors: { password1: "", password2: "", oldPassword: "", show: false },
    passData: { password1: "", password2: "", oldPassword: "" },
    types: {
      password1: "password",
      password2: "password",
      oldPassword: "password"
    },
    errorMessage: ""
  };
  openEditSection = selectedSection => {
    this.setState({
      selectedSection
    });
  };
  onClose = () => {
    this.setState({
      selectedSection: ""
    });
  };
  togglePasswordSection = () => {
    const { passwordSection } = this.state;
    this.setState({ passwordSection: !passwordSection });
  };
  handleChangePassword = e => {
    const { id, value } = e.target;
    const { passData } = this.state;
    this.setState({
      errors: { password1: "", password2: "", show: false },
      passData: { ...passData, ...{ [id]: value } }
    });
  };
  handleSubmit = e => {
    e.preventDefault();
    const { passData } = this.state;
    let hasError = false;
    let password1 = "";
    let password2 = "";
    let oldPassword = "";
    if (!passData.oldPassword || passData.oldPassword.length < 6) {
      hasError = true;
      oldPassword = "Password is not valid";
    }
    if (!passData.password1 || passData.password1.length < 6) {
      hasError = true;
      password1 = "Password is not valid";
    }
    if (!passData.password2 || passData.password2.length < 6) {
      hasError = true;
      password2 = "Password is not valid";
    }
    if (
      (password1 || "").length > 6 &&
      (password2 || "").length > 6 &&
      password1 !== password2
    ) {
      hasError = true;
      password2 = "Password and confirm password does not match";
    }
    if (hasError) {
      this.setState({
        errors: { show: true, password1, password2, oldPassword }
      });
      return;
    }
    Api.post(
      "/api/profile/password",
      { oldPassword: passData.oldPassword, newPassword: passData.password1 },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          const errorMessage = getAppErrors(response.code);
          var body = document.body;
          body.classList.add("body-overflow");
          this.setState({
            errorMessage:
              (errorMessage && errorMessage.message) || response.message
          });
        } else {
          this.setState({
            errors: {
              password1: "",
              password2: "",
              oldPassword: "",
              show: false
            },
            passData: { password1: "", password2: "", oldPassword: "" },
            passwordSection: false
          });
        }
      }
    );
  };
  closeErrorMessage = () => {
    this.setState({ errorMessage: "" });
  };
  handleType = input => {
    const { types } = this.state;
    const current = types[input];
    this.setState({ types: { ...types, ...{ [input]: !current } } });
  };
  render() {
    const {
      selectedSection,
      passwordSection,
      errors,
      passData,
      errorMessage,
      types
    } = this.state;
    const {
      firstName,
      lastName,
      email,
      formErrors,
      submitPhoneNumber,
      active,
      mobileNumber,
      showErrors,
      handleChange,
      handleSubmit,
      onCloseSection,
      loading,
      handleChangePassword,
      handleSubmitPassword,
      smsVerification,
      closeVerification,
      onSmsVerified,
      smsVerified,
      emailVerified,
      sendSmsVerificationKey,
      sendEmailVerificationKey
    } = this.props;

    return (
      (selectedSection && (
        <EditInput
          inputName={selectedSection}
          onChange={handleChange}
          onClose={this.onClose}
          defaultFirstName={firstName}
          defaultLastName={lastName}
          defaultMobileNumber={mobileNumber}
          defaultEmail={email}
          active={active}
          formErrors={formErrors}
          showErrors={showErrors}
          submitPhoneNumber={submitPhoneNumber}
          handleSubmit={handleSubmit}
          smsVerified={smsVerified}
          sendSmsVerificationKey={sendSmsVerificationKey}
          sendEmailVerificationKey={sendEmailVerificationKey}
          handleChangePassword={handleChangePassword}
          handleSubmitPassword={handleSubmitPassword}
          emailVerified={emailVerified}
          smsVerification={smsVerification}
          onSmsVerified={onSmsVerified}
          closeVerification={closeVerification}
        />
      )) || (
        <div className="sign-page edit-profile bg-gray profile-desktop">
          {/* Header */}
          <div className="head-general with-back">
            <a
              onClick={() => onCloseSection("editSection")}
              className="back cursor-pointer"
            >
              <img src="/png/chevron-left.png" />
            </a>
            <h4>Edit Profile</h4>
            <a className="close cursor-pointer" />
          </div>
          {/* Header */}
          <h4 className="hide-xs general-title">
            {passwordSection ? "Change your password" : "Profile"}
          </h4>
          {loading && <Loading />}
          <div className="row">
            {(passwordSection && (
              <div className="col-sm-8 col-md-6">
                <form>
                  <div className="white-bg">
                    <div
                      className={`form-group hide-xs  ${(errors.show &&
                        errors.oldPassword &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="oldPassword"
                        className="form-input"
                        value={passData.oldPassword}
                        type={types.oldPassword}
                        autoCapitalize="none"
                        placeholder="Old Password"
                        onChange={this.handleChangePassword}
                      />
                      <i
                        onClick={() => this.handleType("oldPassword")}
                        className={
                          types.oldPassword
                            ? "icon icon-eye-off-desktop cursor-pointer"
                            : "icon icon-eye-on-desktop cursor-pointer"
                        }
                      />
                      <span>{(errors.show && errors.password1) || ""}</span>
                    </div>
                    <div
                      className={`form-group hide-xs  ${(errors.show &&
                        errors.oldPassword &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="password1"
                        className="form-input"
                        value={passData.password1}
                        type={types.password1}
                        autoCapitalize="none"
                        placeholder="New Password"
                        onChange={this.handleChangePassword}
                      />
                      <i
                        onClick={() => this.handleType("password1")}
                        className={
                          types.password1
                            ? "icon icon-eye-off-desktop cursor-pointer"
                            : "icon icon-eye-on-desktop cursor-pointer"
                        }
                      />
                      <span>{(errors.show && errors.password1) || ""}</span>
                    </div>
                    <div
                      className={`form-group hide-xs  ${(errors.show &&
                        errors.password2 &&
                        "error") ||
                        ""}`}
                    >
                      <input
                        id="password2"
                        className="form-input"
                        autoCapitalize="none"
                        value={passData.password2}
                        type={types.password2}
                        placeholder="Confirm Password"
                        onChange={this.handleChangePassword}
                      />
                      <i
                        onClick={() => this.handleType("password2")}
                        className={
                          types.password2
                            ? "icon icon-eye-off-desktop cursor-pointer"
                            : "icon icon-eye-on-desktop cursor-pointer"
                        }
                      />
                      <span>{(errors.show && errors.password2) || ""}</span>
                    </div>
                  </div>
                  <div className="use-buttons">
                    <button
                      onClick={this.handleSubmit}
                      className={`btn btn-sign register-button hide-xs ${(passData.password1 &&
                        passData.password2 &&
                        "active") ||
                        ""}`}
                      type="submit"
                    >
                      <span>Save</span>
                    </button>
                  </div>
                </form>
                {errorMessage && (
                  <AppErrors
                    message={errorMessage}
                    onClickClose={this.closeErrorMessage}
                  />
                )}
              </div>
            )) || (
              <DesktopEdit
                togglePasswordSection={this.togglePasswordSection}
                handleSubmit={handleSubmit}
                showErrors={showErrors}
                formErrors={formErrors}
                firstName={firstName}
                lastName={lastName}
                email={email}
                emailVerified={emailVerified}
                mobileNumber={mobileNumber}
                active={active}
                handleChange={handleChange}
                submitPhoneNumber={submitPhoneNumber}
                smsVerified={smsVerified}
                sendSmsVerificationKey={sendSmsVerificationKey}
                sendEmailVerificationKey={sendEmailVerificationKey}
                openEditSection={this.openEditSection}
                smsVerification={smsVerification}
                onSmsVerified={onSmsVerified}
                closeVerification={closeVerification}
              />
            )}

            {/* .col-sm-6 */}
          </div>
          {/* .row */}
        </div>
      )
    );
  }
}
